import { useToast } from '@/composables/useToast';
import { useViewerItemStore, ItemSharingMode } from '@/modules/viewer/store/useViewerItemStore';

export const useSecurity = () => {
  const viewerItemStore = useViewerItemStore();
  const { error } = useToast();

  const changeSharingMode = (sharing: ItemSharingMode) => {
    viewerItemStore.saveSecurity({ sharing }).catch(() => {
      error('Cannot update item');
    });
  };

  const changePassword = (password: string) => {
    viewerItemStore.saveSecurity({ sharing: ItemSharingMode.PASSWORD, password }).catch(() => {
      error('Cannot update password');
    });
  };

  const addSharingEmails = (newEmails: string[]) => {
    changeSharingEmails([...(viewerItemStore.sharingSpecificUsers || []), ...newEmails]);
  };

  const changeSharingEmails = (emailShares: string[]) => {
    viewerItemStore.saveSecurity({ emailShares, emailSharesChanged: true }).catch(() => {
      error('Cannot update invitations');
    });
  };

  return { addSharingEmails, changePassword, changeSharingMode, changeSharingEmails };
};
